import React__default from 'react';
import { B as BASE_CONSUMER_ASSETS_URL } from './global-2e5d81b9.js';
import useTheme from './useTheme.js';
import 'styled-components';

/**
 * Used to render an illustration from the Kyte design system.
 * @param name - The name of the illustration to render.
 * @param renderImg - A render prop that allows you to
 * render a custom image component, i.e. `next/image`.
 */
const Illustration = ({
  height,
  name,
  testID,
  width,
  alt,
  renderImg
}) => {
  const [theme] = useTheme();
  const src = `${BASE_CONSUMER_ASSETS_URL}/illustrations/${theme.illustrations}/${name}.png`;
  const altText = alt || `${name} illustration`;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderImg ? renderImg(src) : /*#__PURE__*/React__default.createElement("img", {
    "data-testid": testID,
    alt: altText,
    height: height,
    src: src,
    width: width
  }));
};

export { Illustration as default };
//# sourceMappingURL=Illustration.js.map
